const isProd = process.env.NODE_ENV === "production"

// Server-side only
export const STRIPE_SECRET_KEY = isProd
  ? process.env.STRIPE_SECRET_KEY_PROD
  : process.env.STRIPE_SECRET_KEY_DEV

// Client-safe (NEXT_PUBLIC_)
export const STRIPE_PUBLISHABLE_KEY = isProd
  ? process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_PROD
  : process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_DEV

export const STRIPE_BASIC_PRICE_ID = isProd
  ? process.env.NEXT_PUBLIC_STRIPE_BASIC_PRICE_ID_PROD
  : process.env.NEXT_PUBLIC_STRIPE_BASIC_PRICE_ID_DEV

export const STRIPE_PRO_PRICE_ID = isProd
  ? process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_PROD
  : process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_DEV

// Pro lifetime at 50% off — sold ONLY as the order-bump line item inside
// casper-originated checkout sessions (shared Stripe account). Unset until
// the bundle launches; everything that reads it is env-gated on that.
export const STRIPE_PRO_BUNDLE_PRICE_ID = isProd
  ? process.env.NEXT_PUBLIC_STRIPE_PRO_BUNDLE_PRICE_ID_PROD
  : process.env.NEXT_PUBLIC_STRIPE_PRO_BUNDLE_PRICE_ID_DEV
